import React, { useState } from 'react';
import EventMassiveLoadTable from "./components/EventMassiveLoadTable";

const MassiveLoad = () => {
    return (
        <EventMassiveLoadTable />
    )
};

export default MassiveLoad;